import React from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import RecommendedJob from '../Cards/RecomendedJobCard/RecomendedJobCard';
import classes from './scss/recommendedJobList.module.scss';

function RecommendedJobsList(props) {
  const { jobsData } = props;
  return (
    <div data-testid="list" className={`pt-4 ${classes.container}`}>
      {jobsData?.length === 0 || !Array.isArray(jobsData) ? (
        <h6>
          <Trans i18nKey="dashboard.jobs.nojobssecond">
            No jobs available - <Link to="/dashboard/jobs">view all jobs</Link>
          </Trans>
        </h6>
      ) : (
        jobsData.slice(0, 3).map((item) => <RecommendedJob key={item?.JobTitle} job={item} />)
      )}
    </div>
  );
}

export default RecommendedJobsList;
